import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div
      className="container d-flex flex-column align-items-center justify-content-center py-5"
      style={{ minHeight: "60vh" }}
    >
      <div className="text-center">
        <h1 className="display-1 fw-bold text-main">404</h1>
        <h2 className="mb-4">Page Not Found</h2>
        <p className="lead mb-4 text-muted">
          Oops! The page you are looking for does not exist. It might have been moved or deleted.
        </p>
        <Link to="/" className="btn btn-orange px-4 py-2">
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
